import { makeVar } from '@apollo/client';

const STORAGE_KEY = 'shl:selectedLeagueId';
const NEW_LEAGUE_SENTINEL = '__NEW_LEAGUE__';

const isBrowser = typeof window !== 'undefined';

const normalizeLeagueId = (leagueId) => {
  if (leagueId === undefined) return undefined;
  if (leagueId === null) return null;
  const value = String(leagueId).trim();
  return value || null;
};

const readSelectedLeagueId = () => {
  if (!isBrowser || typeof window.localStorage === 'undefined') return undefined;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === null) return undefined;
    if (raw === NEW_LEAGUE_SENTINEL) return null;
    const normalized = normalizeLeagueId(raw);
    return normalized === null ? undefined : normalized;
  } catch (error) {
    return undefined;
  }
};

const writeSelectedLeagueId = (leagueId) => {
  if (!isBrowser || typeof window.localStorage === 'undefined') return;
  try {
    if (leagueId === undefined) {
      window.localStorage.removeItem(STORAGE_KEY);
      return;
    }
    if (leagueId === null) {
      window.localStorage.setItem(STORAGE_KEY, NEW_LEAGUE_SENTINEL);
      return;
    }
    window.localStorage.setItem(STORAGE_KEY, String(leagueId));
  } catch (error) {
    /* ignore */
  }
};

export const selectedLeagueIdVar = makeVar(readSelectedLeagueId());

export const setSelectedLeagueId = (leagueId) => {
  const normalized = normalizeLeagueId(leagueId);
  if (selectedLeagueIdVar() === normalized) return;
  selectedLeagueIdVar(normalized);
  writeSelectedLeagueId(normalized);
};
